// components/ui/404/404.tsx
"use client";

import { Navbar1 } from '@/components/ui/Standards/navbar';
import { Footer7 } from '@/components/ui/Standards/footer-7';

export default function NotFoundClient() {
  return (
    <>
      <Navbar1 />
      <main style={{ textAlign: 'center', padding: '2rem' }}>
        <h1 className='mt-10 text-4xl font-semibold text-foreground'>404 - Sidan hittades inte</h1>
        <p className='mb-10 text-foreground'>Tyvärr finns inte sidan du söker.</p>
      </main>
      <Footer7 />
    </>
  );
}
